import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { PushNotificationsService } from '@core/services/push-notifications/push-notifications.service';
import { SocketService } from '@core/services/socket.service';
import { sentry } from 'sentry';

@Component({
  selector: 'login-redirect',
  templateUrl: './redirect.component.html'
})
export class LoginRedirectComponent implements OnInit {

  public redirecting: boolean;

  constructor(
    private readonly router: Router,
    private readonly socketService: SocketService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationService: NavigationService,
    private readonly authenticationService: AuthenticationService,
    private readonly pushNotificationsService: PushNotificationsService,
  ) {
    this.redirecting = true;
  }

  public async ngOnInit(): Promise<void> {
    try {
      localStorage.removeItem('AUTH_REDIRECT_URL');

      const { id_token: adIdToken, state } = this.activatedRoute.snapshot.queryParams;
      const parsedState = state && JSON.parse(decodeURIComponent(state));
      const provider = state && parsedState.provider;

      if (!adIdToken || !provider) {
        throw new Error('No id token provided or provider on url params');
      }

      await this.authenticationService.login({ provider, adIdToken });
      const firstVisibleItem = this.navigationService.getFirstVisibleItem(true);
      const redirectToDestinationUrl = localStorage.getItem('REDIRECT_TO_URL_AFTER_LOGIN');
      location.href = redirectToDestinationUrl || firstVisibleItem.url;
      if (redirectToDestinationUrl) {
        localStorage.removeItem('REDIRECT_TO_URL_AFTER_LOGIN');
      }

      this.navigationService.showSupplierIndicationPopUpForCurrentMonth();
      await this.connectSocketAndPushNotifications();
    } catch (err) {
      this.redirecting = false;

      if (err.message === 'No id token provided or provider on url params') {
        return;
      }

      const queryParams = this.activatedRoute.snapshot.queryParams;
      if (!err.error.code || !queryParams.error) {
        sentry.setExtra('error', err);
        sentry.setContext('queryParams', queryParams);
        sentry.captureException(err);
      }
    }
  }

  private async connectSocketAndPushNotifications(): Promise<void> {
    await this.pushNotificationsService.refreshNotificationSubscription();
    await this.socketService.reconnect();
  }

  public gotoLogin(): void {
    this.router.navigateByUrl('/login');
  }
}
